import React from 'react';

export function StatusChip({ kind = 'green', dot = true, children }) {
  const cls = kind === 'green' ? 'sp-chip-green' : kind === 'amber' ? 'sp-chip-amber' : kind === 'red' ? 'sp-chip-red' : kind === 'purple' ? 'sp-chip-purple' : '';
  return (
    <span className={`sp-chip ${cls}`}>
      {dot && <span className="sp-chip-dot" />}
      {children}
    </span>
  );
}
